import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-116" data-mp="1wrauiiecbdep">
      <div className="mx-auto max-w-3xl" data-id="element-117" data-mp="190opz13job9g">
        <SectionHeading eyebrow="Questions" title="Frequently asked questions" data-id="element-118" data-mp="191gjm6dkzyx3" />
        <div className="mt-10 divide-y divide-navy-100 border-y border-navy-100" data-id="element-119" data-mp="142dbgd2b1ckw">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-120" data-mp="1dxx8j2sluhb8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-121" data-mp="1e0t6us8d7807">
                  <span className="text-lg font-bold leading-snug text-ink" data-id="element-122" data-mp="126k8lwlr6zi4">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-123" data-mp="175dplz0918n1" />
                </button>
                <AnimatePresence initial={false} data-id="element-124" data-mp="jgug5g5gqptd">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-125" data-mp="jerhy8u5pqdk">
                      <p className="pb-5 text-base leading-relaxed text-muted" data-id="element-126" data-mp="pl4p1c4tqz5">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <div className="mx-auto mt-10 max-w-xl" data-id="element-127" data-mp="180slyd5qmj9r">
          <CTAButton label="I’m ready — give me access" data-id="element-128" data-mp="134kbve6edg9g" />
        </div>
      </div>
    </section>;
}